import { messages } from "@/messages.en";

/**
 * Keys-not-strings i18n stub (ADR-0041 §"Internationalization", readiness Q5).
 *
 * v1 ships English-only; the `t(key)` indirection means a v1.5 retrofit is a
 * translation-table add — not a code rewrite. The real i18n library (i18next /
 * formatjs / equivalent) is wired in v1.5 per the chip plan Phase 7 conditional.
 *
 * Usage:
 *   import { t } from "@/i18n";
 *   t("home.welcome");
 */
export type MessageKey = keyof typeof messages;

export function t(key: MessageKey): string {
  const value = messages[key];
  if (typeof value !== "string") {
    // Surface missing keys in dev rather than silently rendering the raw key.
    if (import.meta.env.DEV) {
      console.warn(`[i18n] Missing message for key: ${String(key)}`);
    }
    return String(key);
  }
  return value;
}
